import { Stack } from "expo-router";
import React from "react";

function BookingLayout() {
  return (
      <Stack screenOptions={{ headerShown: false }} />

  );
}

export default BookingLayout;
